import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import $ from 'jquery';
import M from 'materialize-css/dist/js/materialize';
import { Link } from 'react-router-dom';
import StartLoadUnload from './StartLoadUnload';
import LoadConfirmation from './LoadConfirmation/LoadConfirmation';
import LoadItem from './LoadItem';

const LoadUnload = (props) => {
    const [table, setTable] = useState(0);

    useEffect(() => {
        const el = $('.tabs');
        M.Tabs.init(el);
        M.Tabs.getInstance(el).select("startLoadUnload");
        // eslint-disable-next-line
    }, []);

    const onSelectedTab = () => {
        const el = $('.tabs');
        let index = M.Tabs.getInstance(el).index;
        if (table !== index) {
            setTable(index);
        }
    };

    return (
        <div className="">
            <div className="third-text-color">
                <div className="row" style={{ marginBottom: '-1px', marginTop: '10px' }}>
                    <ul className="tabs">
                        <li className="tab col s3">
                            <a id="tabStartLoadUnload" className="active" href="#startLoadUnload" onClick={() => onSelectedTab()}>
                                <i className="material-icons prefix">list</i>
                            </a>
                        </li>
                        <li className="tab col s3">
                            <a id="tabConfirmLoadUnload" className="" href="#confirmLoadUnload" onClick={() => onSelectedTab()}>
                                <i className="material-icons prefix">playlist_add_check</i>
                            </a>
                        </li>
                        <Link className="tab col s3" to="../loadunload/parametersConfirmation" >
                            <i className="material-icons">settings</i>
                        </Link>
                    </ul>
                </div>
            </div>
            {/* ---------------- Lista de Desenhos -------------- */}
            <div id="startLoadUnload" className="">
                {
                    table === 0 && (
                        <>
                            <StartLoadUnload {...props} />
                            {
                                props.mvm && props.mvm?.id > 0 &&
                                <LoadItem {...props} />
                            }
                        </>)}
            </div>
            {/* ----------------- Confirmacao das MDRs carregadas ------------- */}
            <div id="confirmLoadUnload" className="col s12">
                {
                    table === 1 && <LoadConfirmation {...props} />
                }
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        config: state.configReducer.config,
        showSupplierComponent: state.loadUnloadReducer.showSupplierComponent,
        mvm: state.loadUnloadReducer.mvm
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LoadUnload));
